import { Controller } from '@hotwired/stimulus'

export default class BaseController extends Controller {
  injectHtmlIntoTarget(
    target: Element,
    html: string | null,
    cb: (() => void) | null = null,
  ): void {
    if (!html || html.trim().length === 0) {
      target.innerHTML = ''
      if (cb) cb()
      return
    }

    const wrapper = document.createElement('div')
    wrapper.innerHTML = html
    const newHtml = wrapper.firstElementChild?.innerHTML ?? html

    // Fade out
    target.classList.add('content-updating')
    target.classList.remove('content-ready')

    requestAnimationFrame(() => {
      target.innerHTML = newHtml

      // Force a reflow so the browser registers the class change
      void (target as HTMLElement).offsetHeight

      // Now the transition will actually run
      target.classList.remove('content-updating')
      target.classList.add('content-ready')

      if (cb) Promise.resolve(cb()).catch(console.error)
    })
  }
}
